import {Box, Button, Typography, Modal, ListItemButton, Collapse, Divider } from "@mui/material"
import { HelpOutlineRounded as HelpOutlineRoundedIcon, 
        LightbulbOutlined as LightbulbOutlinedIcon, 
        SimCardDownloadOutlined as SimCardDownloadOutlinedIcon, 
        MessageOutlined as MessageOutlinedIcon, 
        StoreOutlined as StoreOutlinedIcon,
        ListOutlined as ListOutlinedIcon,
        AddOutlined as AddOutlinedIcon,
        FastfoodOutlined as FastfoodOutlinedIcon,
        PersonAddAltOutlined as PersonAddAltOutlinedIcon,
        EqualizerOutlined as EqualizerOutlinedIcon,
        ExpandMore as ExpandMoreIcon,
        ExpandLess as ExpandLessIcon,
    } from "@mui/icons-material"
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useState, useContext } from "react"
import { ToolContext } from "../../../context/ToolContext";

export const Help = () =>{
    const [open, setOpen] = useState(false)
    const [option, setOption] = useState(false)

    const {personalization_state, tool_state} = useContext(ToolContext)
    const {walkthrough} = personalization_state
    const {__SESSION} = tool_state

    const nav = useHistory()
    const role = __SESSION.data.uaccess[0].role_name

    const handleClick = (name) =>{
        walkthrough.set((prev) => ({...prev, [name]:true}))
    }


    const tours = [
        {name: 'Generate Dashboard Report ', path: '/', icon: EqualizerOutlinedIcon, setter: ()=>{ handleClick('dashboardReport')}},
        {name: 'Generate Branch Product Report', path: '/reports/branch-product', icon: PersonAddAltOutlinedIcon, setter: ()=>{ handleClick('branchProductReport')}},
        {name: 'Generate Branch Sales Report', path: '/reports/branch-sales', icon: PersonAddAltOutlinedIcon, setter: ()=>{ handleClick('branchSalesReport')}},
        {name: 'Create a branch', path: '/setup/branch/create', icon: StoreOutlinedIcon, setter: ()=>{ handleClick('createBranch')}},
        {name: 'Create a category', path: '/setup/category/create', icon: ListOutlinedIcon, setter: ()=>{ handleClick('createCategory')}},
        {name: 'Create a product', path: '/setup/product/create', icon: AddOutlinedIcon, setter: ()=>{ handleClick('createProduct')}},
        {name: 'Create a branch product', path: '/setup/branch-product/create', icon: FastfoodOutlinedIcon, setter: ()=>{ handleClick('createBranchProduct')}},
        {name: 'Create a branch user', path: '/setup/branch-user/create', icon: PersonAddAltOutlinedIcon, setter: ()=>{ handleClick('createBranchUser')}},
    ]

    return (
        <>
            {(role === "Admin" || role === "Super Admin" || role === "Regular User") &&
                <Button id="onboarding-help" sx={{display: "flex", justifyContent: 'start', gap: 1, py:2}} onClick={()=>{setOpen(true)}}>
                    <HelpOutlineRoundedIcon sx={{color: "#929292ff"}}/>
                    <Typography color="#283745" fontSize={12} fontWeight={400} lineHeight="22px">Help</Typography>
                </Button>
            }

            <Modal open={open} slotProps={{backdrop: {sx: { backgroundColor: "transparent", }}}} onClose={()=>{setOpen(false)}} >
                <Box sx={{bgcolor: "#fff", width: 300, p: 2, borderRadius: 2, position: "absolute", left:250, bottom: 100, boxShadow: "0px 8px 16px 0px #00000014, 0px 0px 4px 0px #0000000A", border: "1, #D6D9DB" }}>
                    <Typography sx={{color: "#8F969D", fontWeight: 600, p: 1}}>Help</Typography>
                    <Box  sx={{display: "flex", justifyContent: "start", alignItems: "center", p: 1, gap: 1, "&:hover":{bgcolor: "#E7E8EA"}}} onClick={()=>{setOption(true)}} >
                        <LightbulbOutlinedIcon sx={{fontSize: 24, fontWeight: 200, color: "#292C2F"}}/>
                        <Typography fontWeight={400}>Tour Me</Typography>
                    </Box>
                    <Box sx={{display: "flex", justifyContent: "start", alignItems: "center", p: 1, gap: 1, "&:hover":{bgcolor: "#E7E8EA"}}} >
                        <SimCardDownloadOutlinedIcon sx={{fontSize: 24, fontWeight: 200, color: "#292C2F"}}/>
                        <Typography fontWeight={400}>Work Instruction</Typography>
                    </Box>
                    <Box sx={{display: "flex", justifyContent: "start", alignItems: "center", p: 1, gap: 1, "&:hover":{bgcolor: "#E7E8EA"}}} >
                        <MessageOutlinedIcon sx={{fontSize: 24, fontWeight: 200, color: "#292C2F"}}/>
                        <Typography fontWeight={400}>FAQ's</Typography>
                    </Box>
                </Box>
            </Modal>

            <Modal open={option} slotProps={{backdrop: {sx: { backgroundColor: "transparent", }}}} onClose={()=>{setOption(false); setOpen(false)}} >
                <Box sx={{bgcolor: "#fff", width: 300, p: 2, borderRadius: 2, position: "absolute", left:570, bottom: 100, boxShadow: "0px 8px 16px 0px #00000014, 0px 0px 4px 0px #0000000A", border: "1, #D6D9DB" }}>
                    <Typography sx={{color: "#8F969D", fontWeight: 600, py: 1}}>Tour Me</Typography>
                    {
                        tours.map((tour, index)=>(
                            <Box key={index}>
                                <Box component="button" sx={{border: "none", width: "100%", bgcolor: "transparent", display: "flex", justifyContent: "start", alignItems: "center", p: 1, gap: 1, "&:hover":{bgcolor: "#E7E8EA"}}} onClick={()=>{nav.push(tour.path); setOpen(false); setOption(false); tour.setter();}} >
                                    {/* <tour.icon sx={{fontSize: 28, fontWeight: 400}} /> */}
                                    <Typography sx={{fontWeight: 400, textAlign: "left"}}>{tour.name}</Typography>
                                </Box>
                                <Divider/>
                            </Box>
                        ))

                    }
                </Box>
            </Modal>
        </>
    )
}


export const HelpMobile = () =>{
    const [open, setOpen] = useState(false)
    const [option, setOption] = useState(false)

    const {personalization_state, tool_state} = useContext(ToolContext)
    const {walkthrough} = personalization_state
    const {__SESSION} = tool_state

    const nav = useHistory()
    const role = __SESSION.data.uaccess[0].role_name

    const handleClick = (name) =>{
        walkthrough.set((prev) => ({...prev, [name]:true}))
    }

    const tours = [
        {name: "How to create an Order", description : "Create atleast one order", path: "/", setter: ()=>{ handleClick('order')}},
        {name: "How to create your End of Day Report", description : "Submit End of Day Report", path: "/reports/sales-report", setter: ()=>{ handleClick('eodSalesReport')}},
    ]

    return (
        <>
            {role === "Regular User" &&
                <ListItemButton id="onboarding-help" onClick={()=>setOpen(!open)} sx={{px:'16px !important', display:'flex', justifyContent: "space-between", alignItems:'center', gap:'12px'}} >
                    <Box sx={{display:'flex', alignItems:'center', gap:'12px'}}>
                        <HelpOutlineRoundedIcon sx={{color: '#89A594', fontSize: 20}}/>
                        Help
                    </Box>
                    {open ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
                </ListItemButton>
            }

            <Collapse in={open}>
                <ListItemButton onClick={()=>setOption(true)} sx={{ml: 5, px:'10px !important', display:'flex', alignItems:'center', gap:'12px'}} >
                    Tour Me
                </ListItemButton>
                <ListItemButton sx={{ml: 5, px:'10px !important', display:'flex', alignItems:'center', gap:'12px'}} >
                    Work Instruction
                </ListItemButton>
                <ListItemButton sx={{ml: 5, px:'10px !important', display:'flex', alignItems:'center', gap:'12px'}} >
                    FAQ's
                </ListItemButton>
            </Collapse>

            <Modal open={option}onClose={()=>{setOption(false); setOpen(false)}} >
                <Box sx={{bgcolor: "#fff", width: 300, p: 2, borderRadius: 2, boxShadow: "0px 8px 16px 0px #00000014, 0px 0px 4px 0px #0000000A", border: "1, #D6D9DB",  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    <Typography sx={{color: "#8F969D", fontWeight: 600, py: 1}}>Tour Me</Typography>
                    {
                        tours.map((tour, index)=>(
                            <Box key={index}>
                                <Box component="button" sx={{border: "none", width: "100%", bgcolor: "transparent", display: "flex", justifyContent: "start", alignItems: "center", p: 1, gap: 1, "&:hover":{bgcolor: "#E7E8EA"}}} onClick={()=>{nav.push(tour.path); setOpen(false); setOption(false); tour.setter();}} >
                                    {/* <tour.icon sx={{fontSize: 28, fontWeight: 400}} /> */}
                                    <Typography sx={{fontWeight: 400, textAlign: "left"}}>{tour.name}</Typography>
                                </Box>
                                <Divider/>
                            </Box>
                        ))
                    }
                </Box>
            </Modal>
        </>
    )
}